// client/src/pages/Admin/ResourceManager/utils/resourceStatistics.ts
import { Resource, ResourceStatus } from '../../../../shared/models/Resource';
import { getParentCategory } from './resourceHelpers';

export const computeStatusCounts = (resources: Resource[]) => ({
    all: resources.length,
    [ResourceStatus.DRAFT]: resources.filter((r: Resource) => r.status === ResourceStatus.DRAFT).length,
    [ResourceStatus.PUBLISHED]: resources.filter((r: Resource) => r.status === ResourceStatus.PUBLISHED).length,
    [ResourceStatus.ARCHIVED]: resources.filter((r: Resource) => r.status === ResourceStatus.ARCHIVED).length,
    [ResourceStatus.UNDER_REVIEW]: resources.filter((r: Resource) => r.status === ResourceStatus.UNDER_REVIEW).length
});

export const computeTotalViews = (resources: Resource[]): number => {
    return resources.reduce((sum, r) => sum + (r.views || 0), 0);
};

export const computeTotalDownloads = (resources: Resource[]): number => {
    return resources.reduce((sum, r) => sum + (r.downloadCount || 0), 0);
};

export const extractFilterOptions = (resources: Resource[]) => {
    const parentCategories = new Set<string>();
    const categories = new Set<string>();
    const authors = new Set<string>();
    const years = new Set<string>();

    resources.forEach(resource => {
        // Get parent category
        const parent = getParentCategory(resource.category);
        if (parent) parentCategories.add(parent);

        if (resource.category) categories.add(resource.category);

        if (resource.authors) {
            resource.authors.forEach(author => {
                if (author.name) authors.add(author.name);
            });
        }

        if (resource.publishedDate) {
            try {
                const year = new Date(resource.publishedDate).getFullYear();
                if (year) years.add(year.toString());
            } catch {}
        }
    });

    return {
        parentCategories: Array.from(parentCategories).sort(),
        categories: Array.from(categories).sort(),
        authors: Array.from(authors).sort(),
        years: Array.from(years).sort().reverse()
    };
};

export const getStatusCounts = computeStatusCounts;
export const getTotalViews = computeTotalViews;
export const getTotalDownloads = computeTotalDownloads;
export const getFilterOptions = extractFilterOptions;